import { SkeletonArea } from 'components/skeletonArea';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './SkeletonIppicaArea.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type SkeletonIppicaAreaProps = {
  className?: string;
};
export const SkeletonIppicaArea = ({ className }: SkeletonIppicaAreaProps) => {
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const { isMobile } = useWindowSize();

  return (
    <div className={`${styles.skeleton} ${!isOpen ? styles.withMargin : ''} ${className ? className : ''}`}>
      <SkeletonArea height={isMobile ? '6.6' : '8'} className={styles.titleSkeleton} />
      <SkeletonArea height={isMobile ? '6' : '8.2'} className={styles.infoSkeleton} />
      {!isMobile && (
        <div className={styles.headerSkeletonWrapper}>
          <SkeletonArea height={'1.2'} className={styles.headerSkeleton} />
        </div>
      )}
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
      <SkeletonArea height={isMobile ? '11' : '6.2'} className={styles.rowSkeleton} />
    </div>
  );
};
